// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__u30Rw","total":"AdvancePaymentDetails_total__BsfrP","edit":"AdvancePaymentDetails_edit__ElK0q"};